module.exports = __webpack_public_path__ + "img/yq1.38c83431.png";